<template>
  <section > 
    <b-row> 
      <b-col :md="9"  class="box-effect linear" 
        :class="{'opacity-save': cardHover>1}">
            <validation-observer v-slot="{ invalid } ">    
              <b-card :class="{'border-edit': dataIndex[namePath]!==false}"
                  @mouseover="colMouseLeave()"> 
                  <template v-slot:header >
                    <div class="header-card" :class="{'border-edit': dataIndex[namePath]!==false}" v-if="dataIndex[namePath]===false" >
                      Nueva Afiliación
                    </div>         
                    <div class="header-card" :class="{'text-primary' : dataIndex[namePath]!==false, 'border-edit': dataIndex[namePath]!==false}" v-if="dataIndex[namePath]!==false">
                      Editar Afiliación de {{dataForm[namePath].datos_afiliado.nombre1}} {{dataForm[namePath].datos_afiliado.nombre2}} {{dataForm[namePath].datos_afiliado.apellido1}} {{dataForm[namePath].datos_afiliado.apellido2}} 
                    </div>                              
                  </template>                  
                  <b-form  inline style="margin-bottom:15px;" novalidate>                     
                    <div  style="border:1px solid; border-top:none;border-color: #dee2e6;width:100% ">
                      <b-row v-show="active===0">                     
                        <b-col md="12">
                          <h5 class="title-form">Datos Personales</h5>
                          <b-row  class="row-inputs">
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="id_list_documento"
                                :md="6*cardHover"
                                :lg="3*cardHover"
                              >
                            </sw-inputs>  
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="documento"
                                :md="6*cardHover"
                                :lg="3*cardHover"
                                :searchs="['id_list_estado','id_list_documento','documento','name']"
                                list="datos_afiliado"
                                @buscar="buscarFtn"
                              >
                            </sw-inputs>     
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="nacimiento"
                                :md="6*cardHover"
                                :lg="6*cardHover"
                              >
                            </sw-inputs>                   
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="nombre1"
                                :md="6*cardHover"
                                :lg="3*cardHover"
                              >       
                            </sw-inputs>                            
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="nombre2"
                                :md="6*cardHover"
                                :lg="3*cardHover"
                              >
                            </sw-inputs>                                    
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="apellido1"
                                :md="6*cardHover"
                                :lg="3*cardHover"
                              >
                            </sw-inputs>                       
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="apellido2"
                                :md="6*cardHover"
                                :lg="3*cardHover"
                              >
                            </sw-inputs>               
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="email"
                                :md="6*cardHover"
                                :lg="6*cardHover"
                              >
                            </sw-inputs>                            
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="direccion"
                                :md="6*cardHover"
                                :lg="6*cardHover"
                              >
                            </sw-inputs>                     
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="ciudad"
                                :md="6*cardHover"
                                :lg="6*cardHover"
                              >
                            </sw-inputs>               
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="telefonos"
                                :md="6*cardHover"
                                :lg="6*cardHover"
                              >
                            </sw-inputs>         
                          </b-row>
                        </b-col>   
                        <b-col md="12">
                          <h5 class="title-form">Datos afiliación</h5>
                          <b-row class="row-inputs">           
                              <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="ingreso"
                                @input="changeIngreso"
                                :md="6*cardHover"
                                :lg="6"
                                >
                              </sw-inputs> 
                              <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="id_datos_asesor" 
                                :md="6*cardHover"
                                :lg="6"  >
                              </sw-inputs> 
                              <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="id_datos_razon"
                                @input="changeRazon"
                                :md="6*cardHover"
                                :lg="6"
                                >
                              </sw-inputs>  
                          </b-row>
                        </b-col> 
                        <b-col  md="12"  v-if="active===0">
                          <h5 class="title-form">Servicios</h5>
                          <b-row :class="{'overflow-hidden': cardHover===4}">
                            <sw-tablemultiple
                              style="padding:0"
                              getTable="multiple_servicios"
                              :views="[
                                { th:'Select.', td: 'check'},
                                { th:'Servicio', td: 'name'},
                                { th:'Afiliación', td: 'afiliacion'},
                                { th:'Valor', td: 'valor'},
                              ]"
                              :hideServicio="['Administración','Eps','Riesgo','Ccf','Afp','Traslado']"
                              >
                            </sw-tablemultiple>
                              <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="observacion"
                                :md="12"
                                :lg="12"
                                >
                              </sw-inputs> 
                          </b-row>
                        </b-col>                                               
                        <b-col  md="12" class="mb-3">
                          <h5 class="title-form">Beneficiarios</h5>
                          <sw-tableform
                            :tableItems="beneficiariosItems"
                            tableTabla="afiliado_beneficiarios"
                            :tableCampos="['id','id_datos_afiliado','id_list_documento','name','documento','servicios','nacimiento']"
                            :inits="beneficiariosInits"
                            >                         
                          </sw-tableform>
                        </b-col>                                               
                      </b-row>                      
                    </div>
                  </b-form> 
                  <template  v-slot:footer> 
                    <b-row style="width:100%">
                      <b-col :md="12" :lg="12" v-if="errorsAportes!=='' && errorsAportes!==null">
                          <p  class="text-danger">* {{errorsAportes}}</p>  
                      </b-col>
                      <b-col>      
                        <sw-saveform
                        :invalid="invalidNovedad(invalid) || invalid"
                        limpiar                      
                        :index="dataIndex[namePath]"
                        nameBtn="Afiliado"
                        @limpiar="limpiarForm"
                        @save="saveForm">
                        </sw-saveform> 
                      </b-col>
                    </b-row>       
                  </template>                                         
              </b-card>              
                  </validation-observer>                   
      </b-col>
    </b-row>
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      :hide-backdrop="!openModal.modal.loaded"
      :modal-class="{'d-none': !openModal.modal.loaded}"
      size="lg"  
      @hide="hideModal"

      >        
        <sw-modalafiliacion 
          v-if="openModal.modal.modal==='Afiliacion'"
          @save="saveForm"                     
          >
        </sw-modalafiliacion>  
        <sw-modalafiliaciongrupal 
          v-if="openModal.modal.modal==='AfiliacionGrupal'"
          @save="saveForm"                     
          >
        </sw-modalafiliaciongrupal>     
    </b-modal>
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwSaveform  from '@/components/forms/saveForm.vue'
import SwTablepost  from '@/components/dataTable/tablePost.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwMinform  from '@/components/forms/minform.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import SwModalafiliaciongrupal  from '@/components/modals/afiliacionGrupal.vue'
import SwTableform from '@/components/dataTable/tableForm.vue'
import { ValidationObserver } from 'vee-validate'

export default { 
  name: "afiliacion_nueva",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
    SwInputs,     
    SwTablepost,
    SwSaveform,
    ValidationObserver,
    SwTablemultiple,
    SwMinform,
    SwModalafiliacion,
    SwModalafiliaciongrupal,
    SwTableform
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>